/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

// autogenerated names don't follow camelCase
import type {
  FadeDirection,
  ImageSrcSet,
  MediaImageFragment,
  MediaVideoFragment,
  Tile,
  TileFragment,
} from '../contentTypes';
import { percentageToDecimal } from './utils';

// Image or Video from mediaAsset field
const getMediaAssetContent = (mediaAsset: MediaImageFragment | MediaVideoFragment) => {
  if (mediaAsset?.fields?.assetType === 'image') {
    const { imageUrlSmall, imageUrlLarge } = mediaAsset.fields;
    const smallSrcSet = ['md', 'sm', 'xs'].map((bp) => ({
      bp,
      src: imageUrlSmall?.path || imageUrlLarge?.path || '',
    })) as ImageSrcSet;
    const largeSrcSet = ['xxl', 'xl', 'lg'].map((bp) => ({
      bp,
      src: imageUrlLarge?.path || imageUrlSmall?.path || '',
    })) as ImageSrcSet;
    return {
      assetType: mediaAsset?.fields?.assetType,
      imageEnabled: true,
      videoEnabled: false,
      image: {
        alt: mediaAsset?.fields?.alt,
        srcSet: [...largeSrcSet, ...smallSrcSet],
      },
      video: {
        alt: '',
        autoplay: false,
        loop: false,
        alternateDescriptionPortrait: '',
        audioDescription: {
          path: '',
        },
        audioDescriptionPortrait: {
          path: '',
        },
        closedCaption: {
          path: '',
        },
        closedCaptionPortrait: {
          path: '',
        },
        srcs: {
          xs: { src: '', poster: '' },
          s: { src: '', poster: '' },
          m: { src: '', poster: '' },
          l: { src: '', poster: '' },
          xl: { src: '', poster: '' },
          xxl: { src: '', poster: '' },
        },
      },
    };
  }
  const {
    autoplay,
    loop,
    videoUrlSmall,
    videoUrlLarge,
    posterImageUrlSmall,
    posterImageUrlLarge,
    alternateDescriptionPortrait,
    audioDescription = { path: '' },
    audioDescriptionPortrait = { path: '' },
    closedCaption = { path: '' },
    closedCaptionPortrait = { path: '' },
    alt,
    assetType,
  } = mediaAsset.fields;

  const smallSrcShape = {
    src: videoUrlSmall?.path || '',
    poster: posterImageUrlSmall?.path || '',
  };
  const largeSrcShape = {
    src: videoUrlLarge?.path || '',
    poster: posterImageUrlLarge?.path || '',
  };
  return {
    assetType,
    imageEnabled: false,
    videoEnabled: true,
    image: {
      alt: '',
      srcSet: [
        {
          src: '',
          bp: 'xs',
        },
        {
          src: '',
          bp: 's',
        },
        {
          src: '',
          bp: 'm',
        },
        {
          src: '',
          bp: 'l',
        },
        {
          src: '',
          bp: 'xl',
        },
        {
          src: '',
          bp: 'xxl',
        },
      ] as ImageSrcSet,
    },
    video: {
      alt,
      autoplay,
      loop,
      alternateDescriptionPortrait,
      audioDescription,
      audioDescriptionPortrait,
      closedCaption,
      closedCaptionPortrait,
      srcs: {
        xs: smallSrcShape,
        s: smallSrcShape,
        m: smallSrcShape,
        l: largeSrcShape,
        xl: largeSrcShape,
        xxl: largeSrcShape,
      },
    },
  };
};

export const tileModelToNemo = (tile: TileFragment): Tile => {
  const {
    theme,
    icon,
    mediaAsset,

    logo_alt,
    logo_srcAsset,

    logo_heights_xs,
    logo_heights_s,
    logo_heights_m,
    logo_heights_l,
    logo_heights_xl,
    logo_heights_xxl,

    darkHeadingsEnabled,

    heading_text,
    heading_variant,
    heading_htmlTag,

    subHeading_text,
    subHeading_variant,
    subHeading_htmlTag,

    CTA_href,
    CTA_variant,
    CTA_text,
    CTA_ariaLabel,
    CTA_linkType,
    CTA_openIn,

    horizontalAlignment,

    verticalAlignment,

    wltpKeys,
    disclaimers,

    fadeEnabled,
    fade_color,
    fade_opacity,
    fade_height,
    fade_direction,
  } = tile.fields;

  const newFade = (() => {
    if (fadeEnabled) {
      return {
        color: fade_color || '',
        opacity: percentageToDecimal(fade_opacity) || '',
        height: fade_height || '',
        direction: fade_direction || 'bottom',
      };
    }
    return {
      color: '',
      opacity: '',
      height: '',
      direction: 'bottom' as FadeDirection,
    };
  })();

  const mediaContent = getMediaAssetContent(mediaAsset);

  return {
    CTA: {
      href: CTA_href || '',
      variant: CTA_variant || 'secondary',
      text: CTA_text || '',
      ariaLabel: CTA_ariaLabel || null,
      linkType: CTA_linkType,
      openIn: CTA_openIn,
    },
    darkHeadingsEnabled,
    heading: {
      text: heading_text || '',
      variant: heading_variant || 'order1',
      htmlTag: heading_htmlTag || 'h1',
    },
    horizontalAlignment,
    icon: icon || '',
    logo: {
      alt: logo_alt || '',
      src: logo_srcAsset?.path || '',
      heights: {
        xs: logo_heights_xs || '',
        s: logo_heights_s || '',
        m: logo_heights_m || '',
        l: logo_heights_l || '',
        xl: logo_heights_xl || '',
        xxl: logo_heights_xxl || '',
      },
    },
    wltpKeys,
    disclaimers,
    media: {
      ...mediaContent,
      fadeEnabled,
      fade: newFade,
    },
    subHeading: {
      text: subHeading_text || '',
      variant: subHeading_variant || 'order4',
      htmlTag: subHeading_htmlTag || 'h2',
    },
    theme,
    verticalAlignment,
    fadeEnabled,
    fade: newFade,
  };
};
